import { toast } from "@/ui/Toast/use-toast";
import { REFERRAL_CODE_KEY } from "./constants";

export const ethereumConfig = {
  appIcon: "https://app.thrivecoin.com/favicon.ico",
  walletConnectProjectId: import.meta.env.VITE_WALLETCONNECT_PROJECT_ID,
};

type AuthError = Response | Error | { message?: string };

export const onAuthError = async (error: AuthError) => {
  try {
    if (error instanceof Response) {
      const data = await error.json();
      toast({ title: data.message || "Authentication failed", variant: "destructive" });
    } else if (error instanceof Error) {
      toast({ title: error.message || "Authentication failed", variant: "destructive" });
    } else {
      toast({ title: error.message || "Authentication failed", variant: "destructive" });
    }
  } catch {
    toast({ title: "Authentication failed", variant: "destructive" });
  }
};

export const signInParamsFN = () => {
  const referral_code = sessionStorage.getItem(REFERRAL_CODE_KEY);
  return {
    referral_code,
  };
};
